const PLACEHOLDER_LOCAL_PARTS = new Set(["test", "tester", "example", "demo", "sample"]);
const PLACEHOLDER_DOMAINS = new Set([
  "test.com",
  "example.com",
  "example.org",
  "example.net",
  "invalid",
  "localhost",
]);
const PLACEHOLDER_DOMAIN_LABELS = new Set(["test", "example", "invalid", "localhost", "local"]);

export function isObviouslyPlaceholderEmail(value: string): boolean {
  const normalized = value.trim().toLowerCase();
  const atIndex = normalized.lastIndexOf("@");
  if (atIndex <= 0 || atIndex === normalized.length - 1) return false;

  const localPart = normalized.slice(0, atIndex);
  const domain = normalized.slice(atIndex + 1);
  const labels = domain.split(".").filter(Boolean);
  const root = labels[0] || domain;
  const tld = labels[labels.length - 1] || domain;

  if (PLACEHOLDER_DOMAINS.has(domain)) return true;
  if (PLACEHOLDER_DOMAIN_LABELS.has(root) || PLACEHOLDER_DOMAIN_LABELS.has(tld)) return true;
  if (PLACEHOLDER_LOCAL_PARTS.has(localPart) && PLACEHOLDER_DOMAIN_LABELS.has(root)) return true;

  return false;
}

export function getPasswordRequirementErrors(password: string): string[] {
  const errors: string[] = [];

  if (password.length < 8) errors.push("Password must contain at least 8 characters");
  if (!/[A-Z]/.test(password)) errors.push("Password must contain at least one uppercase letter");
  if (!/[a-z]/.test(password)) errors.push("Password must contain at least one lowercase letter");
  if (!/\d/.test(password)) errors.push("Password must contain at least one digit");
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(password)) {
    errors.push("Password must contain at least one special character");
  }

  return errors;
}

export function validateSignupInput(email: string, password: string): string[] {
  const errors: string[] = [];

  if (isObviouslyPlaceholderEmail(email)) {
    errors.push("Email: Use a real email address. Placeholder/test email addresses are not allowed");
  }

  return [...errors, ...getPasswordRequirementErrors(password)];
}
